export default function getShiftOrders(shiftId, orders = []) {
  return orders.filter(o => o.shiftId === shiftId).reverse()
}
